import { ProjectInterface } from './../../../../model/user/user-project-interface';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DialogService } from '../../../../services/dialog-service/dialog-service.service';
import { HeaderServiceService } from '../../../../services/header-service/header-service.service';
import { SidemenuServiceService } from 'src/app/services/componentServices/sidemenu-service/sidemenu-service.service';
import { UserInterface } from '../../../../model/user/user-interface';
import { UserService } from '../../../../services/user-service/userservice';
import { UtilService } from '../../../../services/util-service/utilService';
import { GENDERS, TITLES, VALIDATOR_EXP } from 'src/environments/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VALIDATORS } from 'src/environments/validators';
import {
    getLocalStorageItem,
    setLocalStorageItem
} from 'src/app/utils/browser-storage';

@Component({
    selector: 'app-settings-screen',
    templateUrl: './settings-screen.component.html',
    styleUrls: ['./settings-screen.component.css'],
    standalone: false
})
export class SettingsScreenComponent implements OnInit {
    public settingsForm: FormGroup;
    public editMode: boolean = false;
    private dialogTitle: string = 'Persönliche Daten';
    private wasProfilePictureChanged: boolean = false;
    private defaultProject: ProjectInterface = {
        projectName: '-',
        userName: this.userservice.currentUser.userName
    };
    private userProjects: ProjectInterface[] = [this.defaultProject];
    private newProjectName: string = '';
    private editModeProjects = false;
    public genders = GENDERS;
    public titles = TITLES;

    get firstName() { return this.settingsForm.get('firstName'); }
    get lastName() { return this.settingsForm.get('lastName'); }
    get employer() { return this.settingsForm.get('employer'); }
    get website() { return this.settingsForm.get('website'); }
    get jobDescription() { return this.settingsForm.get('jobDescription'); }
    get phoneNumber() { return this.settingsForm.get('phoneNumber'); }
    get mobileNumber() { return this.settingsForm.get('mobileNumber'); }

    constructor(
        public userservice: UserService,
        private utilService: UtilService,
        private dialogService: DialogService,
        private sidemenuService: SidemenuServiceService,
        private headerService: HeaderServiceService,
        private titleService: Title,
        private cd: ChangeDetectorRef,
        private fb: FormBuilder
    ) {
        document.documentElement.style.setProperty('--scrollStatus', 'auto');
    }

    ngOnInit() {
        this.sidemenuService.productsVisible = false;
        this.titleService.setTitle('Persönliche Daten - Construct-X');

        this.initializeForm();

        let fullUserName: string =
            this.userservice.currentUser.firstName +
            ' ' +
            this.userservice.currentUser.lastName;
        if (this.userservice.currentUser) {
            this.headerService.loadHeaderText(fullUserName);
            // this.getProjects(this.userservice.currentUser.userName);
        } else {
            if (getLocalStorageItem('refresh_token')) {
                this.headerService.loadHeaderText(fullUserName);

                this.getProjects(this.userservice.currentUser.userName);
            }
        }
        this.loadUserDataIntoForm();
        this.cd.detectChanges();
    }

    private initializeForm(): void {
        this.settingsForm = this.fb.group({
            userName: [{ value: '', disabled: true }],
            gender: [''],
            title: [''],
            firstName: ['', VALIDATORS.firstname],
            lastName: ['', VALIDATORS.lastname],
            phoneNumber: [''],
            mobileNumber: [''],
            employer: ['', VALIDATORS.organization],
            website: ['', VALIDATORS.website],
            jobDescription: ['', VALIDATORS.position],
            hasTrackingConsent: [false],
            fileId: [''],
            // Address fields
            street: [''],
            streetAdditional: [''],
            postalCode: [''],
            city: ['']
        });
        this.settingsForm.disable();
    }

    private loadUserDataIntoForm(): void {
        const user = this.userservice.currentUser;
        
        this.settingsForm.patchValue({
            userName: user.userName,
            gender: user.gender || '',
            title: user.title || '',
            firstName: user.firstName || '-',
            lastName: user.lastName || '-',
            phoneNumber: user.phoneNumber || '-',
            mobileNumber: user.mobileNumber || '-',
            employer: user.employer || '-',
            website: user.website || '-',
            jobDescription: user.jobDescription || '-',
            hasTrackingConsent: user.hasTrackingConsent || false,
            fileId: user.fileId,
            street: user.address?.street || '-',
            streetAdditional: user.address?.streetAdditional || '-',
            postalCode: user.address?.postalCode || '-',
            city: user.address?.city || '-'
        });
    }

    onEditPress(): void {
        this.editMode = !this.editMode;
        this.editModeProjects = false;
        this.wasProfilePictureChanged = false;

        if (this.editMode) {
            this.settingsForm.enable();
            this.settingsForm.get('userName').disable();
            this.replacePlaceholdersWithEmpty();
        } else {
            this.loadUserDataIntoForm();
            this.settingsForm.disable();
            this.settingsForm.markAsUntouched();
            this.settingsForm.markAsPristine();
        }
    }

    onConfirmPress(): void {
        this.settingsForm.markAllAsTouched();

        if (this.settingsForm.invalid) {
            if (this.settingsForm.get('firstName').hasError('required') || 
                this.settingsForm.get('firstName').hasError('firstNameInvalidCharacter') ||
                this.settingsForm.get('lastName').hasError('required') ||
                this.settingsForm.get('lastName').hasError('lastNameInvalidCharacter')) {
                this.dialogService.openDialog(
                    this.dialogTitle,
                    'Bitte geben Sie einen gültigen Vornamen und Nachnamen ein!'
                );
                return;
            }

            if (this.settingsForm.get('employer').hasError('required') ||
                this.settingsForm.get('employer').hasError('organizationLength')) {
                this.dialogService.openDialog(
                    this.dialogTitle,
                    'Bitte geben Sie eine gültige Organisation an.'
                );
                return;
            }

            this.dialogService.openDialog(
                this.dialogTitle,
                'Bitte überprüfen Sie Ihre Eingaben.'
            );
            return;
        }

        setLocalStorageItem(
            'hasTrackingConsent',
            String(this.settingsForm.get('hasTrackingConsent').value)
        );

        const userDetails: UserInterface = this.mapFormToUserInterface();

        this.userservice.changeUserDetails(userDetails).subscribe(
            (res) => {
                this.userservice.currentUser = res;
                if (this.wasProfilePictureChanged) {
                    this.userservice.currentUserPictureChangeSubject.next(true);
                }
                this.onEditPress();
                this.cd.detectChanges();
                let fullUserName: string =
                    this.userservice.currentUser.firstName +
                    ' ' +
                    this.userservice.currentUser.lastName;
                this.headerService.loadHeaderText(fullUserName);

                this.dialogService.openDialog(
                    this.dialogTitle,
                    'Persönliche Daten wurden erfolgreich gespeichert.'
                );
            },
            (error) => {
                console.error('Error saving user details:', error);
            }
        );
    }

    private replacePlaceholdersWithEmpty(): void {
        const controls = this.settingsForm.controls;
        Object.keys(controls).forEach(key => {
            if (controls[key].value === '-') {
                controls[key].setValue('', { emitEvent: false });
            }
        });
    }

    private mapFormToUserInterface(): UserInterface {
        // getRawValue() to also get disabled values
        const formValue = this.settingsForm.getRawValue();
        
        Object.keys(formValue).forEach(key => {
            if (formValue[key] === '-') {
                formValue[key] = '';
            }
        });

        return {
            userId: this.userservice.currentUser.userId,
            userName: formValue.userName,
            gender: formValue.gender || '',
            title: formValue.title || '',
            firstName: formValue.firstName || '',
            lastName: formValue.lastName || '',
            fileId: formValue.fileId,
            website: formValue.website || '',
            employer: formValue.employer || '',
            aboutMe: this.userservice.currentUser.aboutMe || '',
            phoneNumber: formValue.phoneNumber || '',
            mobileNumber: formValue.mobileNumber || '',
            jobDescription: formValue.jobDescription || '',
            hasTrackingConsent: formValue.hasTrackingConsent || false,
            address: {
                street: formValue.street || '',
                streetAdditional: formValue.streetAdditional || '',
                postalCode: formValue.postalCode || '',
                city: formValue.city || ''
            },
            organisationDto: {}
        };
    }
    
    getProjects(userName: string) {
        this.userservice.getUserProjects(userName).subscribe((projects) => {
            this.userProjects = projects;
            this.cd.detectChanges();
        });
    }

    onRemoveProject(projectId: number): void {
        this.dialogService
        .openConfirmDialog(
                'Wollen Sie das Projekt wirklich entfernen?',
                'Abbrechen',
                'Entfernen'
            )
            .subscribe((dialogChoice) => {
                if (dialogChoice) {
                    this.userservice
                    .removeUserProject(projectId)
                    .subscribe(() => {
                            this.getProjects(
                                this.userservice.currentUser.userName
                            );
                        });
                    }
                });
            }
            
    onAddProject(projectName: string) {
        let newProject: ProjectInterface = {
            userName: this.userservice.currentUser.userName,
            projectName: this.newProjectName
        };
        this.userservice.addUserProject(newProject).subscribe(() => {
            this.getProjects(this.userservice.currentUser.userName);
            this.editModeProjects = false;
            this.newProjectName = '';
        });
    }
    
    onFileIdChange(newFileId: string): void {
        this.settingsForm.patchValue({ fileId: newFileId });
        this.wasProfilePictureChanged = true;
    }

    ngOnDestroy(): void {
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');
    }

    checkAndSetPhonenumber(isMobile: boolean = false): void {
        const control = isMobile ? this.mobileNumber : this.phoneNumber;

        const phoneValue = control.value.trim();
        if(isMobile === true) {
            this.mobileNumber.setValue(phoneValue, { emitEvent: false });
        } else {
            this.phoneNumber.setValue(phoneValue, { emitEvent: false });
        }

        if (!phoneValue) {
            return;
        }
    
        if (!this.utilService.validateInternationalPhone(phoneValue)) {
            control.setErrors({ invalidPhone: true });
        }
    }
}
